import InitialState from '../initial-state';
import * as ActionNames from '../action-names';

export default function reducer(
  state = InitialState.getState().recommendedForYou,
  { type, payload }
) {
  switch (type) {
    case ActionNames.GET_BETS_RECOMMENDATIONS: {
      return {
        ...state,
        loading: true,
        error: false
      };
    }
    case ActionNames.GET_BETS_RECOMMENDATIONS_SUCCESS: {
      const { Recommendations } = payload;
      return {
        ...state,
        loading: false,
        error: false,
        betRecommendationIds: Recommendations.map(({ EventId }) => EventId)
      };
    }
    case ActionNames.GET_BETS_RECOMMENDATIONS_FAILED: {
      return {
        ...state,
        loading: false,
        error: true,
        betRecommendationIds: []
      };
    }
    case ActionNames.EVENT_DETAILS_LOADED: {
      return {
        ...state,
        loadedEventIds: [...state.loadedEventIds, payload]
      };
    }
    default:
      return state;
  }
}
